<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">补充约定：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="sup"
        class="my-form"
        title-align="right"
        :data="formData"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="" field="specificClauseExtra" span="24">
        <template v-slot="scope">
          <vxe-input v-model="formData.specificClauseExtra" placeholder="选填" clearable
                     @input="$refs.sup.updateStatus(scope)" maxlength="90"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>

  export default {
    props: ['isSubmit', 'isCancel', 'isSave', 'detailData'],
    data() {
      return {
        formData: {
          specificClauseExtra: null,
        },
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            specificClauseExtra: this.detailData.specificClauseExtra,
          }
        }
      },
    },
    methods: {
      async check() {
        const errMap = await this.$refs.sup.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          specificClauseExtra: this.formData.specificClauseExtra,
        };
        this.$emit("setParams", obj);
      },
      clearValidate() {
        this.$refs.sup.clearValidate();
      },
      reset() {
        this.formData = {
          specificClauseExtra: null,
        };
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>

</style>